// extracted by mini-css-extract-plugin
export default {"timestamp":"styles-module__timestamp___KZHLG"};